// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2HQhF","active":"Button_active__3lCPa","small":"Button_small___-GbO","hidden":"Button_hidden__hsCr2"};